<template>

  <div style="width: 600px; margin: 0 auto; margin-top: 60px;">
    <el-divider content-position="center">
      {{series.name}}
    </el-divider>

    <el-button type="primary" size="small" @click="dialogFormVisible=true">点击新增课程排期</el-button>

    <div v-for="(learnTask, idx) in leanTaskList" :key="idx" style="margin-top: 40px;">
      <el-divider content-position="left">
        {{learnTask.data.themeName}}
      </el-divider>
      <el-upload :action="uploadUrl"
                 :on-remove="handleRemove"
                 :before-remove="beforeRemove"
                 :on-success="handleSuccess"
                 :file-list="learnTask.taskUrlList"
                 :data="learnTask.data">
        <el-button size="small" type="primary">点击上传课程资料</el-button>
      </el-upload>
    </div>

    <el-dialog title="新增课程排期" :visible.sync="dialogFormVisible" width="30%">
      <el-form :inline="true" :model="theme" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="theme.name" size="small" placeholder="请输入课程名称名称" style="width: 360px;"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="addLearnTask">确认新增</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
  import { doGetLearnTaskView, doDeleteLearnTask } from '@/utils/server';

  export default {
    name: "add",
    data() {
      return {
        dialogFormVisible: false,
        series: {
          code: '',
          name: '',
          sort: 0,
        },
        theme: {
          code: '',
          name: ''
        },
        themeCode: '',
        themeName: '',
        leanTaskList: []
      };
    },
    methods: {
      getLearnTaskView() {
        doGetLearnTaskView({ seriesCode: this.series.code })
          .then(response => {
            let leanTasks = [];
            response.data.forEach(function (item) {
              let leanTask = {};
              leanTask.data = {};
              leanTask.data.seriesCode = item.seriesCode;
              leanTask.data.seriesName = item.seriesName;
              leanTask.data.seriesSort = item.seriesSort;

              leanTask.data.themeCode = item.themeCode;
              leanTask.data.themeName = item.themeName;

              leanTask.data.maxSort = item.maxSort;

              leanTask.taskUrlList = [];
              item.taskUrlList.forEach(function (ite) {
                leanTask.taskUrlList.push({
                  id: ite.id,
                  name: ite.name,
                  url: ite.url,
                  sort: ite.sort
                });
              });
              leanTasks.push(leanTask);
            });
            this.leanTaskList = leanTasks;

            if (this.leanTaskList.length > 0) {
              this.series.code = this.leanTaskList[this.leanTaskList.length - 1].data.seriesCode;
              this.series.name = this.leanTaskList[this.leanTaskList.length - 1].data.seriesName;
              this.series.sort = this.leanTaskList[this.leanTaskList.length - 1].data.seriesSort;
            }
          });
      },
      addLearnTask() {
        this.series.sort = this.series.sort + 1;
        this.leanTaskList.push({
          data: {
            seriesCode: this.series.code,
            seriesName: this.series.name,
            seriesSort: this.series.sort,
            themeCode: this.getUid(),
            themeName: "（" + this.series.name + "）" + this.theme.name,
            maxSort: 0
          },
          taskUrlList: [],
        });
        this.theme.name = '';
        this.dialogFormVisible = false;
      },
      handleRemove(file) {
        doDeleteLearnTask({ id: file.id || file.response })
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      handleSuccess(response, file, fileList) {
        this.leanTaskList.forEach(function (item) {
          console.log(response + ' -- ' + item.data.themeCode);
           if (response == item.data.themeCode){
             console.log("----")
             item.data.maxSort = item.data.maxSort + 1;
           }
        });
      },
      getUid() {
        return new Date().getTime() + "";
      }
    },
    computed: {
      uploadUrl() {
        return process.env.SERVER_ADDRESS + '/api/file/fileUpload';
      },
    },
    mounted() {
      this.series.code = this.$route.query.seriesCode;
      this.series.name = this.$route.query.seriesName;
      this.getLearnTaskView();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/learntask/addedit.vue